import { SORTING, DEFAULT_SORTING } from '../constants';

export const getSortingOptions = () =>
  Object.keys(SORTING).map(key => SORTING[key]);

export const isDefaultSort = value => value === DEFAULT_SORTING;

export const getSortingName = (sortByValue, variantName) =>
  isDefaultSort(sortByValue) && variantName ? variantName : sortByValue;

export default {
  isDefaultSort,
  getSortingOptions,
  getSortingName
};
